import { initLoginPage } from "../reducers/LoginReducer";
import AppUtil, { getAppURL } from "./../../../utils/AppUtil";
import UI_CONSTANTS from "./../../app/constants/UIConstants";

export const initLoginComp = appHashPath => {
  return dispatch => {
    const isResetPassword =
      appHashPath && appHashPath.indexOf(UI_CONSTANTS.RESET_PW_URL_HASH) !== -1;
    const URL = `${getAppURL("LOGIN_LAYOUT")}${isResetPassword ? "?isResetPassword=Y" : ""}`;

    AppUtil.ajax(URL, undefined, response => {
      processLayout(response);

      dispatch(initLoginPage(response));
    });
  };
};

export const validateCaptcha = (turnstileToken, setState, callbackFn, expectedAction) => {
  if (!turnstileToken) {
    return;
  }

  const URL = getAppURL("CAPTCHA_VALIDATION");

  AppUtil.ajax(
    URL,
    { cfTurnstileToken: turnstileToken, expectedAction },
    async response => {
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.valid) {
          callbackFn();
        } else {
          setState(prev => ({ turnstileToken: null, widgetKey: prev.widgetKey + 1 }));
        }
      } else {
        setState(prev => ({ turnstileToken: null, widgetKey: prev.widgetKey + 1 }));
      }
    },
    undefined,
    true
  );
};

export const processLayout = layoutConfig => {
  const { css } = layoutConfig;

  if (css) {
    const style = document.createElement("style");
    style.innerHTML = css;

    document.head.appendChild(style);
  }
};

export const validResetLink = callbackFn => {
  const resetDetails = location.pathname.replace("/auth/login/", "");

  AppUtil.ajax(
    getAppURL("VALID_RESET_PWD_LINK"),
    {
      details: resetDetails
    },
    response => {
      callbackFn(response);
    }
  );
};
